import "./ActionButton.css";
/*
Button for actions, hide text when mobile

IsDesktop: Display in desktop mode or not => boolean
Label: Label of the button => string
Title: Title of the button, use Label if null => string
Icon: Icon element to display => React Object
Disabled: If button is disabled => boolean
OnClickButton : Function on click => function
*/
const ActionButton = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const Label = props.Label;
  const Title = props.Title;
  const Icon = props.Icon;
  const Disabled = props.Disabled;
  const onClickButton = props.OnClick;
  const ButtonStyle = props.buttonStyle;
  const IconStyle = props.iconStyle;

  if (IsDesktop)
    return (
      <div className={"actionbutton_cont " + (Disabled ? "actionbutton_disabled_cont" : "")} title={Title || Label} onClick={Disabled ? undefined : onClickButton} style={ButtonStyle}>
        <div className="actionbutton_text">
          {Label}
        </div>
        <div className={"actionbutton_icon " + (Disabled ? "actionbutton_disabled_icon" : "")} style={IconStyle}> 
          <Icon />
        </div>
      </div>
    );


  //Mobile
  return (
    <div className={"actionbutton_mobile_cont " + (Disabled ? "actionbutton_disabled_cont" : "")} title={Title || Label} onClick={Disabled ? undefined : onClickButton} style={ButtonStyle}>
      <div className="actionbutton_mobile_icon" style={IconStyle}>
        <Icon />  
      </div>
    </div>
  )

};

export default ActionButton;